// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ipYFk","productName":"Table_productName__3hOWS"};